import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { SvgLibraryNewIcon } from '@finnairoyj/fcom-ui-styles';

import { CmsArticle } from '@fcom/core-api';
import { NotificationTheme } from '@fcom/ui-components';

@Component({
  selector: 'cms-icon-with-text',
  template: `
    <fcom-notification [theme]="theme()" [iconName]="icons()">
      <span [innerHTML]="content() | finMap: 'detailText' | finSafe: 'html'"></span>
    </fcom-notification>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CmsIconWithTextComponent {
  content = input<CmsArticle>();

  readonly title = computed<string | undefined>(() => {
    const content = this.content();
    return content?.teaserTitle ?? undefined;
  });

  readonly icons = computed<SvgLibraryNewIcon | undefined>(() => {
    const iconName = this.content().localSettings?.iconName;
    return ((Array.isArray(iconName) ? iconName[0] : iconName) as SvgLibraryNewIcon) ?? undefined;
  });

  readonly theme = computed<NotificationTheme | undefined>(() => {
    const tags = this.content().subjectTaxonomyTags ?? [];
    return tags.map((tag) => this.tagToTheme(tag)).find((theme) => !!theme) ?? NotificationTheme.INFO;
  });

  private tagToTheme(tag: string): NotificationTheme {
    if (tag.includes('signal-warning')) {
      return NotificationTheme.WARNING;
    }
    if (tag.includes('signal-error')) {
      return NotificationTheme.ERROR;
    }
    if (tag.includes('signal-success')) {
      return NotificationTheme.SUCCESS;
    }
    return NotificationTheme.INFO;
  }
}
